import type { InboxResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** The signed-in member's inbox, as of now (INB-1 to INB-9). */
export function useInbox() {
  return useQuery({
    queryKey: ['pages', 'inbox'],
    queryFn: () => apiRequest<InboxResponse>('/api/pages/inbox'),
    staleTime: 60_000,
  });
}
